// extracted by mini-css-extract-plugin
export var readonly = "_hx-1";
export var star = "_hx-0";